<template>
  <div>
    <Menu />
    <section id="banner" class="my-2">
      <div class="col-12 position-relative">
        <div class="banner-section" id="home-banner">
          <video
            class="w-100 rounded banner-desktop banner-video"
            autoplay
            muted
            loop
            playsinline
          >
            <source src="/images/chas-lux-banner.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          <img
            src="/images/home-banner-mobile.png"
            alt="luxury property and lifestyle banner"
            class="w-100 rounded banner-mobile"
          />
        </div>

        <div class="location-search-overlay">
          <div class="search-wrapper">
            <input
              type="text"
              class="form-control search-input"
              placeholder="Search a location..."
              v-model="locationSearch"
              @input="handleLocationSearch"
              @keyup.enter="goSearch"
            />

            <select
              class="search-lifestyle-select"
              v-model="selectedLifestyle"
              @change="updateStoreLifestyle"
            >
              <option value="">Choose your lifestyle</option>
              <option value="inland">Inland</option>
              <option value="coastal">Coastal</option>
              <option value="countryside">Countryside</option>
              <option value="city">City</option>
            </select>

            <select
              class="search-type-select"
              v-model="selectedType"
              @change="updateStoreTypeAndPrice"
            >
              <option value="">Buy / Rent</option>
              <option value="buy">Buy</option>
              <option value="rent">Rent</option>
            </select>

            <select
              class="search-price-select"
              v-model.number="maxPrice"
              @change="updateStorePrice"
            >
              <option :value="150000000">Price Range</option>

              <option v-if="selectedType !== 'rent'" :value="20000000">Up to R 20m</option>
              <option v-if="selectedType !== 'rent'" :value="30000000">Up to R 30m</option>
              <option v-if="selectedType !== 'rent'" :value="50000000">Up to R 50m</option>
              <option v-if="selectedType !== 'rent'" :value="75000000">Up to R 75m</option>
              <option v-if="selectedType !== 'rent'" :value="100000000">Up to R 100m</option>
              <option v-if="selectedType !== 'rent'" :value="150000000">Up to R 150m</option>

              <option v-if="selectedType === 'rent'" :value="60000">Up to R 60k</option>
              <option v-if="selectedType === 'rent'" :value="80000">Up to R 80k</option>
              <option v-if="selectedType === 'rent'" :value="100000">Up to R 100k</option>
              <option v-if="selectedType === 'rent'" :value="150000">Up to R 150k</option>
              <option v-if="selectedType === 'rent'" :value="250000">Up to R 250k</option>
            </select>

            <button type="button" class="search-inside-btn" @click="goSearch">
              <img
                src="/images/search-icon.png"
                alt="luxury property and lifestyle banner"
                class="w-100 rounded"
              />
            </button>
          </div>

          <ul
            v-if="locationSuggestions.length > 0 && locationSearch !== ''"
            class="list-group location-suggestions"
          >
            <li
              v-for="(suggestion, i) in locationSuggestions"
              :key="suggestion + i"
              class="list-group-item"
              @click="selectSuggestion(suggestion)"
            >
              {{ suggestion }}
            </li>
          </ul>
        </div>
      </div>

      <div class="container">
        <div class="row justify-content-center g-0">
          <div class="container">
            <div class="row justify-content-center"></div>

            <div class="row">
              <div class="col-12 text-center">
                <h2 class="pt-4 pb-2">BROWSE OUR LUXURY LIFESTYLE PROPERTIES</h2>
                <p>
                  Discover a curated collection of South Africa’s most prestigious properties,
                  available to rent or buy.
                  From exquisite coastal estates and <br />
                  majestic safari lodges to enchanting vineyard retreats and sprawling farm
                  manors,
                  each home showcases breathtaking landscapes <br />
                  and unrivalled craftsmanship - the true epitome of luxury living.
                </p>

                <a
                  class="btn big-filter-btn big-filterOne"
                  :class="{ active: selectedType === 'rent' }"
                  href="/portfolio"
                >
                  Buy A PROPERTY
                </a>

                <a
                  class="btn big-filter-btn big-filterOne"
                  :class="{ active: selectedType === 'rent' }"
                  href="/rentals"
                >
                  RENT A PROPERTY
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

   <div class="container-fluid">
      <div class="row">
        <div class="col-12 text-center">
          <a href="/developments" id="luxury-developments-banner" class="d-none d-md-block">
            <img
              src="images/developments-banner.jpg"
              class="img-fluid py-5"
              alt="Luxury Developments Collection"
            />
          </a>

          <a href="/developments" id="luxury-developments-button" class="d-block d-md-none">
            <img
              src="images/developments-banner.jpg"
              class="img-fluid py-4"
              alt="Luxury Developments Collection"
            />
          </a>
        </div>
      </div>
    </div> 

    <FeaturedProperty />
    <FeaturedRental />

    <div class="container-fluid">
      <div class="row">
        <div class="col-12 text-center">
          <a href="/signature-farms" id="signature-farms-banner" class="d-none d-md-block">
            <img
              src="images/banner-farms-desktop.png"
              class="img-fluid py-5"
              alt="Signature Farms Collection"
            />
          </a>

          <a href="/signature-farms" class="d-block d-md-none">
            <img
              src="images/banner-farms-mobile.png"
              class="img-fluid py-4"
              alt="Signature Farms Collection"
            />
          </a>
        </div>
      </div>
    </div>

    <Search />
    <LifestyleFeed />
    <SellWithUs />
    <div class="mb-5"></div>
    <Footer />
  </div>
</template>

<script>
import axios from 'axios'
import Menu from '@/components/home/Menu.vue'
import FeaturedProperty from '@/components/home/FeaturedProperty.vue'
import FeaturedRental from '@/components/home/FeaturedRental.vue'
import Search from '@/components/home/Search.vue'
import LifestyleFeed from '@/components/home/LifestyleFeed.vue'
import SellWithUs from '@/components/home/SellWithUs.vue'
import SeoLinks from '@/components/home/SeoLinks.vue'
import Footer from '@/components/home/Footer.vue'

export default {
  components: {
    Menu,
    FeaturedProperty,
    Search,
    LifestyleFeed,
    SellWithUs,
    SeoLinks,
    Footer,
    FeaturedRental
  },
  data() {
    return {
      listings: [],
      selectedType: '',
      selectedLocations: [],
      selectedLifestyle: "",
      maxPrice: 150000000,
      minPrice: 10000000,
      highToLow: true,
      locationSearch: "",
      allLocations: [],
      locationSuggestions: [],
    }
  },
  mounted() {
    this.fetchLocations();
  },
  methods: {
    toggleType(type) {
      if (type === 'buy' || type === 'rent') {
        this.$store.commit('setFilter', { filter: 'buy', value: type === 'buy' });
        this.$store.commit('setFilter', { filter: 'rent', value: type === 'rent' });
        this.selectedType = this.selectedType === type ? null : type;
        this.$store.commit('setMaxPrice', this.maxPrice);
      }
    },

    toggleLocation(location) {
      const index = this.selectedLocations.indexOf(location);

      if (index !== -1) {
        this.selectedLocations.splice(index, 1);
      } else {
        this.selectedLocations.push(location);
      }

      this.$store.commit('setFilter', {
        filter: location,
        value: !this.$store.state.search.tags[location]
      });

      this.$store.commit('setMaxPrice', this.maxPrice);
    },

    updateStorePrice() {
      this.$store.commit('setMaxPrice', this.maxPrice);
    },

    updateStoreTypeAndPrice() {
      this.$store.commit('setFilter', { filter: 'buy', value: this.selectedType === 'buy' });
      this.$store.commit('setFilter', { filter: 'rent', value: this.selectedType === 'rent' });
      this.$store.commit('setMaxPrice', this.maxPrice);
    },

    updateStoreLifestyle() {
      if (!this.selectedLifestyle) {
        return;
      }
    },

    async fetchLocations() {
      try {
        const response = await axios.get(
          this.$store.state.apiBaseUrl + "fetch_listings.php"
        );

        const listings = response.data;
        const set = new Set();

        if (!Array.isArray(listings)) {
          this.allLocations = [];
          return;
        }

        for (let i = 0; i < listings.length; i++) {
          const item = listings[i];

          if (!item) continue;
          if (!item.payload) continue;
          if (!item.payload.listing) continue;
          if (!item.payload.listing.data) continue;
          if (!item.payload.listing.data.listing) continue;

          const listingRoot = item.payload.listing.data.listing;
          let l = null;

          if (Array.isArray(listingRoot)) {
            if (listingRoot.length > 0) {
              l = listingRoot[0];
            }
          } else {
            if (listingRoot["0"]) {
              l = listingRoot["0"];
            }
          }

          if (!l) continue;

          const suburb = l.loc_suburb ? String(l.loc_suburb).trim() : "";
          const region = l.loc_region ? String(l.loc_region).trim() : "";

          if (!suburb) continue;
          if (!region) continue;

          set.add(suburb + ", " + region);
        }

        this.allLocations = Array.from(set).sort();
      } catch (e) {
        console.error("Location fetch failed", e);
        this.allLocations = [];
      }
    },

    handleLocationSearch() {
      this.locationSuggestions = this.allLocations.filter(loc =>
        loc.toLowerCase().includes(this.locationSearch.toLowerCase())
      );
    },

    selectSuggestion(suggestion) {
      this.locationSearch = suggestion;
      this.locationSuggestions = [];
    },

    goSearch() {
      const q = this.locationSearch.trim();

      const dest = this.selectedType === "rent"
        ? "/rentals"
        : "/portfolio";

      const query = {
        maxPrice: this.maxPrice
      };

      if (q) {
        query.search = q;
      }

      if (this.selectedLifestyle) {
        query.lifestyle = this.selectedLifestyle;
      }

      this.$router.push({
        path: dest,
        query,
        hash: '#top'
      });
    }
  }
}
</script>

<style scoped>
.location-search-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70%;
  z-index: 10;
}

/* Main bar = glass pill */
.search-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 999px;
  overflow: hidden;

  background: rgba(255, 255, 255, 0.18);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(12px);

  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 10px 30px rgba(0,0,0,0.25);
}

/* Left input looks more "solid white" */
.search-input {
  flex: 1;
  border: none;
  padding: 20px 22px;
  font-size: 1.05rem;
  outline: none;
  border-radius: 999px;

  background: rgba(255, 255, 255, 0.95);
  color: #111;
}

.search-input::placeholder {
  color: rgba(0, 0, 0, 0.5);
}

.search-input:focus {
  outline: none;
  box-shadow: none;
}

/* Dropdowns = transparent-ish like screenshot */
.search-type-select,
.search-price-select,
.search-lifestyle-select {
  border: none;
  padding: 14px 18px;
  font-size: 1.1rem;
  cursor: pointer;
  outline: none;
  height: 100%;

  background: transparent;
  color: rgba(0, 0, 0, 0.75);

  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  padding-right: 34px;
  position: relative;
}

/* Vertical separators between select blocks */
.search-type-select,
.search-price-select {
  border-left: 1px solid rgba(255, 255, 255, 0.25);
}

/* Add dropdown chevron */
.search-type-select,
.search-price-select,
.search-lifestyle-select {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='rgba(0,0,0,0.55)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
}

/* Search button = circle on the far right */
.search-inside-btn {
  border: none;
  background: rgba(255, 255, 255, 0.92);
  width: 52px;
  height: 52px;
  border-radius: 45%;
  margin: 6px;
  font-size: 1.35rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 6px 18px rgba(0,0,0,0.25);
  transition: transform 0.12s ease, opacity 0.12s ease;
}

.search-inside-btn:hover {
  transform: scale(1.03);
  opacity: 1;
}

/* Suggestions dropdown */
.location-suggestions {
  margin-top: 10px;
  max-height: 180px;
  overflow-y: auto;
  cursor: pointer;
  border-radius: 14px;

  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);

  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 12px 25px rgba(0,0,0,0.25);
}

/* Mobile support */
@media (max-width: 1070px) {
  .location-search-overlay {
    width: 92%;
    top: 60%;
  }

  .search-wrapper {
    flex-wrap: wrap;
    border-radius: 24px;
    padding: 6px;
    gap: 6px;
  }

  .search-input {
    flex: 1 1 100%;
    width: 100%;
    border-radius: 18px;
    padding: 14px 16px;
    font-size: 1rem;
  }

  .search-lifestyle-select,
  .search-type-select,
  .search-price-select {
    flex: 1 1 calc(33.333% - 6px);
    min-width: 0;
    height: 44px;
    padding: 10px 12px;
    font-size: 0.95rem;
    border-left: none;
    border-radius: 14px;
    background-color: rgba(255, 255, 255, 0.35);
  }

  .search-price-select {
    flex: 1 1 calc(50% - 6px);
  }

  .search-inside-btn {
    flex: 0 0 48px;
    width: 48px;
    height: 48px;
    margin: 0;
    border-radius: 15px;
  }

  .search-inside-btn img {
    width: 20px !important;
    height: 20px !important;
    border-radius: 0 !important;
  }

  .location-suggestions {
    width: 100%;
    border-radius: 14px;
  }
}

/* Extra small phones */
@media (max-width: 420px) {
  .location-search-overlay {
    width: 94%;
    top: 62%;
  }

  .search-lifestyle-select,
  .search-type-select,
  .search-price-select {
    flex: 1 1 calc(50% - 6px);
    height: 42px;
    font-size: 0.92rem;
    padding: 10px 10px;
    background-position: right 10px center;
  }

  .search-input {
    padding: 12px 14px;
    font-size: 0.98rem;
  }

  .search-inside-btn {
    flex: 1 1 100%;
    width: 100%;
    height: 46px;
    border-radius: 16px;
  }

  .search-inside-btn img {
    width: 18px !important;
    height: 18px !important;
  }
}
</style>